@use '../../styles/box-sizing';

:host > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: var(--der-ui-spacing-XS);
}
